import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import classNames from 'classnames';
import type { FC } from 'react';

import Button from '../Button';
import Text from '../Text';

export const buttonStyles = cva(
  'flex flex-row gap-4  border px-2 py-1 md:px-4',
  {
    variants: {
      variant: {
        gray: 'rounded-lg border-[#666666] text-neutral-1000',
        successTransparent:
          'rounded-[1.25rem] border-jobBoardSuccessStroke text-jobBoardSuccessText',
        successBg:
          'rounded-[1.25rem] border-jobBoardSuccessStroke bg-jobBoardSuccessBackground text-jobBoardSuccessText',
      },
    },
    defaultVariants: {
      variant: 'gray',
    },
  }
);

type Props = {
  label: string;
  suffixIcon?: string | IconDefinition;
  onSuffixIconClick?: () => void;
  suffixIconClassName?: string;
  className?: string;
  prefix?: JSX.Element;
  labelClassName?: string;
} & VariantProps<typeof buttonStyles>;

const Chip: FC<Props> = ({
  label,
  suffixIcon,
  onSuffixIconClick,
  suffixIconClassName,
  variant,
  className,
  prefix,
  labelClassName,
}) => {
  return (
    <div className={classNames(buttonStyles({ variant }), className)}>
      {prefix && prefix}
      <Text
        variant="body-caption"
        className={classNames('font-semibold', labelClassName)}
      >
        {label}
      </Text>
      {suffixIcon && (
        <Button
          size="xs"
          variant="unstyled"
          onClick={onSuffixIconClick}
          suffixIcon={suffixIcon}
          className={classNames(suffixIconClassName)}
        />
      )}
    </div>
  );
};

export default Chip;
